const a = (t) => () => t.get("/config/latest-data-version", {});
export {
  a as getChainTilesTaBatchId
};
//# sourceMappingURL=index.es495.js.map
